var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-chat-template"},[_c('img',{staticClass:"phone-chat-img",attrs:{"src":"//cnstatic01.e.vhall.com/static/images/menu/chat-temp-new-h5.png","alt":""}}),_c('span',{staticClass:"phone-welcome"},[_c('span',[_vm._v("游客***")]),_vm._v(" "+_vm._s(_vm.menuInfo.welcome_content || '欢迎你的到来观看')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }